// extracted by mini-css-extract-plugin
export default {"container":"RevenueExtraFilter_container__ppDQg","selectLabel":"RevenueExtraFilter_selectLabel__OGh5Y","fullWidth":"RevenueExtraFilter_fullWidth__GZYoW"};